import { useEffect, useState } from 'react';
import { toast } from '../../../util/toasts';
import { useOrderApiV1 } from '../../../clients/quipli-service/order/order-api-v1';
import { Order, OrderMedia, OrderMediaType } from '../../../clients/quipli-service/order/order';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';

export const useOrderMedia = (order?: Order) => {
  const { getUploadOrderMediaUrl, addOrderMedia } = useOrderApiV1();
  const { listOrderMedia } = useOrderApiV1();
  const { uploadToS3 } = useAPI();

  const [isOrderMediaLoading, setIsOrderMediaLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);

  const [mediaList, setMediaList] = useState<OrderMedia[]>([]);

  const upload = async (files: File[], filenamePrefix: string, prefetch: (...arg: any[]) => Promise<void>) => {
    if (order?.id === undefined) return;

    setIsUploading(true);

    for (const file of files) {
      const type = file.type.match('image/*') ? OrderMediaType.Image : OrderMediaType.Video;

      try {
        const { url: preSignedUrl, mediaId } = await getUploadOrderMediaUrl(
          order.id,
          `${filenamePrefix}${file.name}`,
          type,
        );
        // Save to S3
        await uploadToS3(preSignedUrl, file);
        // Save to DB
        await addOrderMedia(order.id, mediaId, file.name, type);

        await prefetch(mediaId);

        await fetch();
        toast(`${file.name} uploaded successfully.`);
      } catch (error: any) {
        console.error(error);
        toast(
          `Error uploading ${file.name}: ${error.message.msg || error.message || error.msg || 'Something went wrong.'}`,
          'error',
        );
      } finally {
        setIsUploading(false);
      }
    }
  };

  const fetch = async () => {
    if (!order?.id) return;
    try {
      setIsOrderMediaLoading(true);

      setMediaList(await listOrderMedia(order.id));
    } catch (error: any) {
      toast(error.message.msg || error.message, 'error');
    } finally {
      setIsOrderMediaLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [order]);

  return {
    isOrderMediaLoading,
    mediaList,
    fetch,
    upload,
    isUploading,
  };
};
